<template>
  <v-card outlined height="100%">
    <v-row class="py-4">
      <v-col cols="9">
        <v-card outlined>
          <v-card-title>Kontaktfelder</v-card-title>
          <!-- {{kontaktfelder}} -->
          <v-card-subtitle>Neben festen Kontaktfeldern können beliebig viele eigene Kontaktfelder hinzugefügt werden.</v-card-subtitle>
          <v-divider></v-divider>
          <!-- ToDo: formatter und Linke/Rechte Seite -->
          <v-row class="py-2 px-0">
            <v-col cols="3">
              <v-card outlined>
                <v-card-title>
                  Pflichtfelder
                </v-card-title>
                <v-card-subtitle class="text-caption">
                  Pflichtfelder können nicht entfernt werden, da sie für die Anwendung zwingend notwendig sind.
                </v-card-subtitle>
                <v-card-text>
                  <span v-for="(item, index) in pflichtFelder" :key="index" class="mr-2">
                    <v-chip label small :class="kontaktfelder.find(val => val.value === item.value) ? 'green' : ''" outlined class="mt-1">
                      <v-icon v-if="kontaktfelder.find(val => val.value === item.value)" small color="green" class="mr-1">check</v-icon>
                      {{ item.label }}
                    </v-chip>
                  </span>
                </v-card-text>
                <v-card-title>
                  Standardfelder
                </v-card-title>
                <v-card-subtitle class="text-caption">
                  Standardfelder sind nicht verpflichtend bieten aber einige Vorteile, da sie z.B. in Widgets verwendet werden.
                </v-card-subtitle>
                <v-card-text>
                  <span v-for="(item, index) in standardFelder" :key="index" class="mr-2">
                    <v-chip @click="addStandardfeld(item)" label small :class="kontaktfelder.find(val => val.value === item.value) ? 'green' : ''" outlined class="mt-1">
                      <v-icon v-if="kontaktfelder.find(val => val.value === item.value)" small color="green" class="mr-1">check</v-icon>
                      {{ item.label }}
                    </v-chip>
                  </span>
                </v-card-text>
                <v-card-title>
                  Gelöschte Felder
                </v-card-title>
                <v-card-subtitle class="text-caption">
                  Eigene Felder die du gelöscht hast. Du kannst sie erneut hinzufügen.
                </v-card-subtitle>
                <v-card-text>
                  <span v-for="(item, index) in deletedFelder" :key="index" class="mr-2">
                    <v-chip label small :class="kontaktfelder.find(val => val.value === item.value) ? 'green' : ''" outlined class="mt-1">
                      <v-icon v-if="kontaktfelder.find(val => val.value === item.value)" small color="green" class="mr-1">check</v-icon>
                      {{ item.label }}
                    </v-chip>
                  </span>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="9">
              <v-card outlined>
                <v-simple-table height="650px" fixed-header dense>
                  <thead>
                    <tr>
                      <th></th>

                      <th>Variable Kontaktfelder</th>
                      <th>Art</th>
                      <th>Bearbeitbar</th>
                      <th>Feldbreite</th> show: false,
                      <th width="20px" class="text-center">Im Profil-Dialog zeigen</th>
                      <th></th>
                    </tr>
                  </thead>
                  <draggable v-model="kontaktfelder" @change="updateKontaktfelder()" group="myGroup" tag="tbody">
                    <tr v-for='(item, index) in kontaktfelder' :key='index'>
                      <td width="20px"><v-icon class="grey--text">drag_indicator</v-icon></td>
                      <td>{{ item.label }}</td>
                      <td width="170px"><v-select v-if="!item.default" hide-details dense outlined @change="updateKontaktfelder()" :items="types" v-model="item.type"></v-select></td>
                      <td v-if="item.type === 'Select' && !item.default">
                        <v-combobox hide-details="auto" hint="Optionen Eingeben und mit Enter bestätigen" v-model="item.options" multiple small-chips deletable-chips outlined dense></v-combobox>
                      </td>
                      <td v-else></td>
                      <td width="50px"><v-select hide-details dense flat @change="updateKontaktfelder()" :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]" v-model="item.breite"></v-select show: false,></td>
                      <td width="20px" v-if="item.show"><v-btn icon @click="(item.show = !item.show ); updateKontaktfelder()"><v-icon >check_box</v-icon></v-btn></td>
                      <td width="20px" v-else><v-btn icon @click="(item.show = !item.show ); updateKontaktfelder()"><v-icon >check_box_outline_blank</v-icon></v-btn></td>
                      <td width="20px"><v-btn v-if="!item.required" icon @click="dropKontaktfeld(item)"><v-icon>delete</v-icon></v-btn></td>
                    </tr>
                  </draggable>
                </v-simple-table>
                <v-card-actions>
                  <v-text-field dense outlined hide-details label="Kontaktfeld hinzufügen" append-outer-icon="add" @click:append-outer="addKontaktfeld" v-model="kontaktfeld"></v-text-field>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card outlined>
          <v-card-title>Status</v-card-title>
          <v-card-subtitle>Definiert die Auswahlmöglichkeiten des Feld "Status". Kontakte die Mitglied sind können Informationen von anderen Mitglieder ansehen.</v-card-subtitle>
          <v-divider></v-divider>
          <v-simple-table dense height="400px" fixed-header>
            <thead>
              <tr>
                <th>Status</th>
                <th class="text-center">gilt als Mitglied</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for='item in alleStatus' :key='item.status'>
                <td>{{ item.status }}</td>
                <td class="text-center" v-if="(item.mitglied === true)"><v-btn icon @click="toggleMitglied(item)"><v-icon>check_box</v-icon></v-btn></td>
                <td width="20px" class="text-center" v-else><v-btn icon @click="toggleMitglied(item)"><v-icon>check_box_outline_blank</v-icon></v-btn></td>
                <td width="20px"><v-btn icon @click="dropStatus(item)"><v-icon>delete</v-icon></v-btn></td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-card-actions>
            <v-text-field dense outlined hide-details label="Status hinzufügen" append-outer-icon="add" @click:append-outer="addStatus" v-model="status"></v-text-field>
          </v-card-actions>
        </v-card>
        <v-card outlined>
          <v-card-title>Finanzfelder</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-checkbox label="SEPA-Lastschriftmandat abfragen" @change="updateKontaktfelder()" v-model="finanzFelder.showSepaMandat" hide-details density="compact"></v-checkbox>
            <v-checkbox label="IBAN, BIC etc. abfragen" @change="updateKontaktfelder()" v-model="finanzFelder.showBankdaten" hide-details density="compact"></v-checkbox>
          </v-card-text>
          <v-simple-table dense height="200px" fixed-header>
            <thead>
              <tr>
                <th>Beitragsfelder</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for='item in finanzFelder.beitrage' :key='item.status'>
                <td>{{ item.label }}</td>
                <td width="20px"><v-btn icon @click="dropBeitrag(item)"><v-icon>delete</v-icon></v-btn></td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-card-actions>
            <v-text-field dense outlined hide-details label="Status hinzufügen" append-outer-icon="add" @click:append-outer="addBeitrag()" v-model="finanzBeitrag"></v-text-field>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    
  </v-card>
</template>

<script>
  import draggable from 'vuedraggable'
  export default {
    components: {
      draggable
    },
    data () {
      return {
        status: '',
        finanzBeitrag: '',
        kontaktfeld: '',
        alleStatus: [],
        kontaktfelder: [],
        deletedFelder: [],
        pflichtFelder: [
          { default: true, required: true, breite: 6, show: false, label: 'Briefanrede', value: 'briefanrede', type: 'Briefanrede' },
          { default: true, required: true, breite: 6, show: false, label: 'Vorname', value: 'vorname', type: 'String' },
          { default: true, required: true, breite: 6, show: false, label: 'Nachname', value: 'nachname', type: 'String' },
          { default: true, required: true, breite: 12, show: false, label: 'Adresse', value: 'adresse', type: 'String' },
          { default: true, required: true, breite: 4, show: false, label: 'PLZ', value: 'plz', type: 'String' },
          { default: true, required: true, breite: 4, show: false, label: 'Ort', value: 'ort', type: 'String' },
          { default: true, required: true, breite: 4, show: false, label: 'Land', value: 'land', type: 'String' },
          { default: true, required: true, breite: 12, show: false, label: 'Email', value: 'email', type: 'String' },
          { default: true, required: true, breite: 12, show: false, label: 'Status', value: 'status', type: 'Status' }
        ],
        standardFelder: [
          { default: true, required: false, breite: 3, show: false, label: 'Anrede', value: 'anrede', type: 'Anrede' },
          { default: true, required: false, breite: 3, show: false, label: 'Titel', value: 'titel', type: 'String' },
          { default: true, required: false, breite: 4, show: false, label: 'Vulgo', value: 'vulgo', type: 'String' },
          { default: true, required: false, breite: 6, show: false, label: 'Geburtsdatum', value: 'geburtsdatum', type: 'Date' },
          { default: true, required: false, breite: 6, show: false, label: 'Hochzeitsdatum', value: 'hochzeitsdatum', type: 'Date' },
          { default: true, required: false, breite: 6, show: false, label: 'Todesdatum', value: 'todesdatum', type: 'Date' },
          { default: true, required: false, breite: 12, show: false, label: 'Studiengang', value: 'studiengang', type: 'String' },
          { default: true, required: false, breite: 6, show: false, label: 'Telefon', value: 'telefon', type: 'Telefon' },
          { default: true, required: false, breite: 6, show: false, label: 'Handy', value: 'handy', type: 'Telefon' },
          { default: true, required: false, breite: 6, show: false, label: 'Leibvater', value: 'leibvater', type: 'Leibvater' },
          { default: true, required: false, breite: 6, show: false, label: 'Receptionsdatum', value: 'receptionsdatum', type: 'Date' },
          { default: true, required: false, breite: 6, show: false, label: 'Philistrierungsdatum', value: 'philistrierungsdatum', type: 'Date' },
          { default: true, required: false, breite: 6, show: false, label: 'Urverbindung', value: 'urverbindung', type: 'Verbindung' },
          { default: true, required: false, breite: 6, show: false, label: 'ZM/Bandverbindung', value: 'zm', type: 'Verbindungen' },
          { default: true, required: false, breite: 6, show: false, label: 'Zirkel', value: 'zirkel', type: 'Zirkel' },
          { default: true, required: false, breite: 12, show: false, label: 'Gruppen', value: 'gruppen', type: 'Gruppen' }
        ],
        defaultFinanzFelder: {
          beitrage: [],
          showSepaMandat: true,
          showBankdaten: true
        },
        finanzFelder: [],
        defaultKontaktfelder: [
          { default: true, required: true, breite: 6, show: false, label: 'Briefanrede', value: 'briefanrede', type: 'Briefanrede' },
          { default: true, required: true, breite: 6, show: false, label: 'Vorname', value: 'vorname', type: 'String' },
          { default: true, required: true, breite: 6, show: false, label: 'Nachname', value: 'nachname', type: 'String' },
          { default: true, required: true, breite: 12, show: false, label: 'Adresse', value: 'adresse', type: 'String' },
          { default: true, required: true, breite: 4, show: false, label: 'PLZ', value: 'plz', type: 'String' },
          { default: true, required: true, breite: 4, show: false, label: 'Ort', value: 'ort', type: 'String' },
          { default: true, required: true, breite: 4, show: false, label: 'Land', value: 'land', type: 'String' },
          { default: true, required: true, breite: 12, show: false, label: 'Email', value: 'email', type: 'String' },
          { default: true, required: true, breite: 12, show: false, label: 'Status', value: 'status', type: 'Status' }
        ],
        alleKontaktfelder: [],
        types: ['String', 'Number', 'Date', 'Select']
      }
    },
    methods: {
      close () {
        this.$emit('close', false)
      },
      addStatus () {
        this.alleStatus.push({
          status: this.status,
          mitglied: false
        })
        this.status = ''
        this.updateStatus()
      },
      dropStatus (item) {
        this.alleStatus.splice(this.alleStatus.indexOf(item), 1)
        this.updateStatus()
      },
      toggleMitglied (item) {
        this.alleStatus[this.alleStatus.indexOf(item)].mitglied = !this.alleStatus[this.alleStatus.indexOf(item)].mitglied
        this.updateStatus()
      },
      addBeitrag () {
        this.finanzFelder.beitrage.push(
          { default: true, required: false, breite: 6, show: false, label: this.finanzBeitrag, value: this.finanzBeitrag.toLowerCase().replace(' ', ''), type: 'money' }
        )
        this.finanzBeitrag = ''
        this.updateKontaktfelder()
      },
      dropBeitrag (item) {
        this.finanzFelder.beitrage.splice(this.finanzFelder.beitrage.indexOf(item), 1)
        this.updateKontaktfelder()
      },
      updateStatus () {
        let object = ({
          status: this.alleStatus
        })
        this.$firebase.firestore().collection('vereine').doc(this.$vars.verbindung).collection('einstellungen').doc('mitgliederstatus').update(object)
          .then(() => {
          })
          .catch(error => {
            console.log(error)
          })
      },
      addKontaktfeld () {
        this.alleKontaktfelder.push({
          label: this.kontaktfeld,
          value: this.kontaktfeld.toLowerCase().replace(/\s+/g, ''),
          type: 'String',
          options: [],
          show: false
        })
        this.kontaktfelder.push({
          default: false,
          required: false,
          label: this.kontaktfeld,
          value: this.kontaktfeld.toLowerCase().replace(/\s+/g, ''),
          type: 'String',
          breite: 6,
          options: [],
          show: false
        })
        this.kontaktfeld = ''
        this.updateKontaktfelder()
      },
      addStandardfeld (item) {
        if (!this.kontaktfelder.find(val => val.value === item.value)) {
          this.kontaktfelder.push(item)
        }
      },
      dropKontaktfeld (item) {
        this.alleKontaktfelder.splice(this.alleKontaktfelder.indexOf(item), 1)
        this.kontaktfelder.splice(this.kontaktfelder.indexOf(item), 1)
        this.updateKontaktfelder()
      },
      updateKontaktfelder () {
        let object = ({
          felder: this.alleKontaktfelder,
          neuFelder: this.kontaktfelder,
          finanzFelder: this.finanzFelder
        })
        this.$firebase.firestore().collection('vereine').doc(this.$vars.verbindung).collection('einstellungen').doc('kontaktfelder').update(object)
          .then(() => {
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    beforeMount () {
      this.$firebase.firestore().collection('vereine').doc(this.$vars.verbindung).collection('einstellungen').doc('mitgliederstatus').get()
      .then(doc => {
        if (!doc.exists) {
          this.$firebase.firestore().collection('vereine').doc(this.$vars.verbindung).collection('einstellungen').doc('mitgliederstatus').set({
            was: 'mitgliederstatus',
            status: []
          })
        } else {
          this.alleStatus = doc.data().status
        }
      })
      .catch(err => {
        console.log('Error getting document', err)
      })
      this.$firebase.firestore().collection('vereine').doc(this.$vars.verbindung).collection('einstellungen').doc('kontaktfelder').get()
      .then(doc => {
        if (!doc.exists) {
          this.$firebase.firestore().collection('vereine').doc(this.$vars.verbindung).collection('einstellungen').doc('kontaktfelder').set({
            id: 'kontaktfelder',
            felder: [],
            neuFelder: [],
            finanzFelder: {}
          })
          this.kontaktfelder = this.defaultKontaktfelder
          this.finanzFelder = this.defaultFinanzFelder
        } else {
          console.log(doc.data())
          this.alleKontaktfelder = doc.data().felder || []
          this.kontaktfelder = doc.data().neuFelder || this.defaultKontaktfelder
          this.finanzFelder = doc.data().finanzFelder || this.defaultFinanzFelder
        }
      })
      .catch(err => {
        console.log('Error getting document', err)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Kontakte.vue?2bf95ca9